// extracted by mini-css-extract-plugin
module.exports = {"badgeGroupContainer":"StatusTagGroup_badgeGroupContainer__4Q87N","badgeWrapper":"StatusTagGroup_badgeWrapper__AT_1T"};